import Vue from 'vue'
import store from '@/store'

Vue.filter('bankCodeName', (val = '') => {
  const rVal = store.getters['code/bank/getBank'](val)
  return rVal == null ? val : rVal.name
})
